import { defineNuxtRouteMiddleware } from 'nuxt/app'
import { createError } from 'h3'

const endsWithNoindex = (path: string) => path.endsWith('/noindex/')
const startsWithLang = (path: string, lang: string) =>
  path.startsWith(`/${lang}/`)
const hasAmpersandBeforeQueryOrHash = (path: string) => {
  const queryIndex = path.indexOf('?')
  const hashIndex = path.indexOf('#')
  const firstAmpIndex = path.indexOf('&')
  if (firstAmpIndex === -1) {
    return false
  }
  return firstAmpIndex < Math.min(queryIndex, hashIndex)
}

const languagePrefixes = [
  'pt',
  'de-ch',
  'sl',
  'ro',
  'fr-ch',
  'lv',
  'de-hr',
  'sk',
  'lt',
  'zh',
]

const shouldReturn404 = (path: string): boolean =>
  endsWithNoindex(path) ||
  languagePrefixes.some((lang) => startsWithLang(path, lang)) ||
  hasAmpersandBeforeQueryOrHash(path)

export default defineNuxtRouteMiddleware((to) => {
  const path = to.fullPath
  if (shouldReturn404(path)) {
    throw createError({
      statusCode: 404,
      statusMessage: `Resource not found: ${path}`,
      fatal: process.client,
    })
  }
})
